import { render, staticRenderFns } from "./LoyaltyDetails.vue?vue&type=template&id=51f729ce"
import script from "./LoyaltyDetails.vue?vue&type=script&lang=ts"
export * from "./LoyaltyDetails.vue?vue&type=script&lang=ts"
import style0 from "./LoyaltyDetails.vue?vue&type=style&index=0&id=51f729ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports